import React from "react";
import { classnames as cx } from "@mna/react";
import { Trans } from "react-i18next";
import i18next from "i18next";
import terms from "assets/img/terms.png";
import LoadingScreen from "features/LoadingScreen";
export default ({ setState, actions, state, history }) => {
	function checkBox() {
		var check = document.getElementsByClassName("check");
		if (check[0].checked) {
			setState({ item: true });
		} else {
			setState({ item: false });
		}
	}

	return (
		<LoadingScreen isLoading={state.isLoading}>
			<div className="page-section-1">
				<div className="container-2 w-container">
					<div className="w-row">
						<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
						<div className="column column-2 w-col w-col-5 w-col-tiny-tiny-stack w-form-label-justify">
							<div className="w-col w-col-tiny-tiny-stack">
								{state.PolicyKey == "ExpiredPolicyKeyMsg" ? (
									<div className="w-col w-col-tiny-tiny-stack">
										<p><Trans i18nKey="checkpolicy.expiredpolicykeymsg">
											Unfortunately we are unable to verify an active policy with
											the information you have provided.
										</Trans></p>
									</div>
								) : (
									<div className="w-col w-col-tiny-tiny-stack">
										<p>
											<strong>
												<Trans i18nKey="checkpolicy.futurepolicykeymsg-bold">
													Set up is complete
												</Trans>
											</strong>
											<Trans i18nKey="checkpolicy.futurepolicykeymsg">
												, however your policy activation date is on the
											</Trans>
											<strong> {state.PolicyKeyDate}</strong>
											<Trans i18nKey="checkpolicy.futurepolicykeymsg1">
												, you will be able to use the service then, please contact
												GEM on 1-866-566-1463 for more information.
											</Trans>
										</p>
									</div>
								)}
							</div>
							<div className="w-col w-col-tiny-tiny-stack">
								<p>
									<Trans i18nKey="checkpolicy.msg-1">
										If you believe this is an error or if you require immediate
										attention please call the number on your policy card.
									</Trans>
								</p>
							</div>
							<div className="w-col w-col-tiny-tiny-stack">
								<p>
									<strong><Trans i18nKey="checkpolicy.msg-2">
										If this is a medical emergency please seek local care.
									</Trans></strong>
								</p>
							</div>
							<div className="continue-btn">
								<button
									className="button1 btn standby-button-gradient standby-button-gradient-blue"
									onClick={(e) => {
										e.preventDefault();
										actions.azureLogout(actions, state, history);
										setState({
											showModal: false,
										});
									}}
								>
									<Trans i18nKey="findcareoption.OK">OK</Trans>
								</button>
							</div>
						</div>
						<div className="w-col w-col-6 w-col-tiny-tiny-stack">
							<img src={terms} loading="lazy" className="t-img" />
						</div>
					</div>
				</div>
			</div>
		</LoadingScreen>
	);
};
